import { Syncable } from "shared/state/models/syncable";
import { IDiagnoseCategory } from "shared/api/api";


export const SAVE_DIAGNOSECATEGORY = 'SAVE_DIAGNOSECATEGORY';
export const DELETE_DIAGNOSECATEGORY = 'DELETE_DIAGNOSECATEGORY';
export const SYNC_DATA_DIAGNOSECATEGORIES = 'SYNC_DATA_DIAGNOSECATEGORIES';

export interface DiagnoseCategoryState extends Syncable<IDiagnoseCategory> {}
